export * from './map-browser.component';
export * from './map-browser-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/map-browser/index.ts